<mapfre-header></mapfre-header>
<div class="container mapfre-content account-type-select">
    <mapfre-card additionalClasses="select-acct-type"
      [additionalCardContentClasses]="'select-acct-type'">
        <div class="acc-type-header">
            <div class="acc-type-header-title">
                {{ 'ABOUT_POLICY' | translate }}
            </div>
            <div class="acc-type-header-sub">
                {{ 'WHAT_TYPE_OF_POLICY' | translate }}
            </div>
        </div>
        <div class="row acc-type-sec">
            <a class="col insurance-type personal-ins" routerLink="/signup" (click)="openSignup()">
                <div>
                    <figure>
                        <img src="./assets/img/images/account-user-dark.svg" alt="personal" />
                      </figure>
                </div>
                <div class="acc-type-font">{{ 'PERSONAL_INSURANCE' | translate }}</div>
            </a>
            <a class="col insurance-type" routerLink="/signup/create-commercial-account" (click)="openCommercialAccount()">
                <div>
                    <figure>
                        <img src="./assets/img/images/icon-business-dark.svg" alt="business" />
                      </figure>
                </div>
                <div class="acc-type-font">{{ 'BUSINESS_INSURANCE' | translate }}</div>                
            </a>
        </div>
        <div class="row margin-top mt24 text-center checkingrowbtm">
            <div class="col">
                <ng-container *ngIf="isAcmic else backButtonForMA">
                    <mapfre-button
                        (click)="goBack()"
                        additionalClasses="link-button small-btn blue-link no-margin button-border-red"
                        [customIcon]="'assets/img/icons/back-arrow.png'"
                        [backIcon]="'assets/img/icons/back-arrow-red.png'"
                        [iconClasses]="'align-middle'"
                        [showIconsCustom]="true"
                    >  {{ 'BACK' | translate }}
                    </mapfre-button>
                </ng-container>
                <ng-template #backButtonForMA>
                    <mapfre-button
                        (click)="goBack()"
                        additionalClasses="link-button small-btn red-link no-margin button-border-red"
                        [customIcon]="'assets/img/icons/back-arrow.png'"
                        [backIcon]="'assets/img/icons/back-arrow-red.png'"
                        [iconClasses]="'align-middle'"
                        [showIconsCustom]="true"
                    >  {{ 'BACK' | translate }}
                    </mapfre-button>
                </ng-template>

            </div>
          </div>
    </mapfre-card>
</div>